<template>
    <v-layout v-if="$can('manage', 'model')">
        <v-flex xs12>
            <v-card>
                <v-card-title class="headline primary white--text">
                    Model
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="accent" @click="dialog=true;editedItem=null" :disabled="!$can('update', 'Model')"><v-icon small>fa-plus</v-icon> Add Model</v-btn>
                    <model-record-dialog v-model="dialog" :item="editedItem"></model-record-dialog>
                </v-card-actions>
                <v-card-text>
 <v-data-table
                    :headers="headers"
                    :items="points"
                    class="elevation-1"
            >
      <template v-slot:items="props">
        <td>{{ props.item.model_id }}</td>
        <td class="text-xs-left">{{ props.item.model_name }}</td>
        <td class="text-xs-left">
            {{props.item.model_type}}
        </td>
        <td class="text-xs-left">{{ props.item.model_status }}</td>
        <td class="text-xs-left">{{ props.item.topic }}</td>
        <td class="text-xs-left">{{ props.item.model_active }}</td>
        <td class="text-xs-left">{{ props.item.equipment_name}}</td>
        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="$can('update', 'Model') && editItem(props.item)"
          >
            fa-edit
          </v-icon>
          <v-icon
            small
            @click="$can('update', 'Model') && deleteItem(props.item)"
          >
            fa-trash
          </v-icon>
        </td>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>
    </v-data-table>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
import {getModel, deleteModel} from '../helper'
import ModelRecordDialog from '../components/model/ModelRecordDialog'

export default {
    name: 'Model',
  components: { ModelRecordDialog },
  data: () => ({
      dialog: false,
      headers: [

        {
          text: 'Model ID',
          align: 'left',
          sortable: true,
          value: 'model_id'
        },
        { text: 'Model Name', value: 'model_name' },
        { text: 'Model Type', value: 'model_type' },
        { text: 'Status', value: 'model_status'},
        { text: 'Topic', value: 'topic'},
        { text: 'Active', value: 'model_active'},
        { text: 'Equipment Name', value: 'equipment_name'},
        { text: 'Action', sortable: false },
      ],
      points: [

      ],
      editedIndex: -1,
      editedItem: {
      },
    }),
    watch: {
      dialog (newdialog ) {
        this.refresh()
      }
    },
  mounted() {
    this.initialize()
  },
    methods: {
      initialize () {
        this.refresh()
      },

      editItem (item) {
        this.editedIndex = this.points.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      async deleteItem (item) {
        const index = this.points.indexOf(item)
        if (confirm('Are you sure you want to delete this item?') ){
          this.points.splice(index, 1)
          await deleteModel({
            'model_id': item.model_id
          })
          this.refresh()
        }
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        if (this.editedIndex > -1) {
          Object.assign(this.points[this.editedIndex], this.editedItem)
        } else {
          this.points.push(this.editedItem)
        }
        this.close()
      },
      async refresh() {
        let df = await getModel({
          facility_name: this.$store.state.pointsListStore.pointsList.facility_name,
        })
        this.points = df['result']
      }
    }
  }
</script>

<style scoped>

</style>
